import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectBoxProps {
  id?: string;
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  fullWidth?: boolean;
  required?: boolean;
}

/**
 * Custom SelectBox component
 * Selection component that provides consistent styling and a user-friendly API
 */
export const SelectBox: React.FC<SelectBoxProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  fullWidth = false,
  required = false,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl sx={{ minWidth: 200, width: fullWidth ? '100%' : 'auto' }} required={required}>
      <InputLabel id={`${id || 'select'}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id || 'select'}-label`}
        id={id}
        value={value}
        label={label}
        onChange={handleChange}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBox;
